import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export type HistoryConversationActionSource = 'sidebar' | 'session-history' | 'seo' | 'reel' | 'image' | 'insight';

export type HistoryConversationChange =
  | {
      type: 'create';
      sessionId: string;
      source: HistoryConversationActionSource;
    }
  | {
      type: 'rename';
      sessionId: string;
      title: string;
      source: HistoryConversationActionSource;
    }
  | {
      type: 'delete';
      sessionId: string;
      source: HistoryConversationActionSource;
    }
  | {
      type: 'read';
      sessionId: string;
      source: HistoryConversationActionSource;
    }
  | {
      type: 'resume';
      sessionId: string;
      source: HistoryConversationActionSource;
    };

interface HistoryConversationState {
  version: number;
  lastChange: HistoryConversationChange | null;
  notifyHistoryChanged: (change: HistoryConversationChange) => void;
}

export const useHistoryConversationStore = create<HistoryConversationState>()(
  devtools(
    (set) => ({
      version: 0,
      lastChange: null,
      notifyHistoryChanged: (change) =>
        set((state) => ({
          version: state.version + 1,
          lastChange: change,
        })),
    }),
    { name: 'history-conversation' },
  ),
);
